import React from "react";
import { Tabs } from "antd";

const TabUi = ({ tabId, setTabId }) => {
    return (
        <Tabs
            className="mx-2 text-base"
            popupClassName="mb-0"
            tabBarStyle={{
                marginBottom: 0,
            }}
            activeKey={tabId}
            defaultActiveKey={tabId}
            items={[
                { label: "Autosys rules", key: "autosys_rules" },
                { label: "System rules", key: "system_rules" },
            ]}
            onChange={(value) => {
                setTabId(value);
            }}
        />
    );
};

export default TabUi;
